export const METRICS_NAMES_LOCALE_KEYS_MAP: {
  [key: string]: string;
} = {
  PCU: 'dbi_metric_pcu',
  'Steam PCU': 'dbi_metric_steam_pcu',
  'Steam ACU': 'dbi_metric_steam_acu',
  'Steam Revenue': 'dbi_metric_steam_revenue',
  'Digital Revenue': 'dbi_metric_digitalRevenueNoDo',
  'Digital Revenue($)': 'dbi_metric_digitalRevenue',
  'US Digital Revenue($)': 'dbi_metric_usdigitalRevenue',
  'Digital ARPPU($)': 'dbi_metric_digital_arpu_$',
  'US Digital ARPPU($)': 'dbi_metric_usdigital_arpu_$',
  'Digital Units': 'dbi_metric_units',
  'Steam Units': 'dbi_metric_steam_units',
  'Est Units': 'dbi_label_metric_est_units',
  MAU: 'dbi_metric_mau',
  'Hours Watched': 'dbi_metric_hourswatched_simple',
  'Peak CCV': 'dbi_metric_peakccv',
  'Physical Revenue($)': 'dbi_metric_physical_revenue',
  'US Physical Revenue($)': 'dbi_metric_usphysical_revenue',
  'Sales of selected time': 'dbi_metric_jptb_sales',
  'Cumulative Sales of the latest week': 'dbi_metric_jptb_cumulative_sales',
  'Cumulative Revenue of the latest week($)': 'dbi_metric_jptb_cumulative_revenue',
  'Lifetime Player': 'dbi_metric_lifetime_player',
  Downloads: 'dbi_downloads',
  DAU: 'dbi_dau',
  WAU: 'dbi_wau',
  'Revenue($)': 'dbi_revenue_$',
  RPD: 'dbi_rpd',
  Retention: 'dbi_metric_retention',
  'Retention D2': 'dbi_metric_retention_d2',
  'Retention D3': 'dbi_metric_retention_d3',
  'Retention D7': 'dbi_metric_retention_d7',
  'Retention D15': 'dbi_metric_retention_d15',
  'Retention D31': 'dbi_metric_retention_d31',
  'Mobile Revenue($)': 'dbi_company_metrics_mobile_revenue',
  'PC Digital Revenue($)': 'dbi_company_metrics_pc_digital_revenue',
  'PC Physical Revenue($)': 'dbi_company_metrics_pc_physical_revenue',
  'Console Digital Revenue($)': 'dbi_company_metrics_console_digital_revenue',
  'Console Physical Revenue($)': 'dbi_company_metrics_console_physical_revenue',
  'Retention D 1': 'dbi_KPIOverview_d1',
  Acu: 'dbi_metric_acu',
  'Est Price': 'dbi_metric_price_dol',
  Airtime: 'dbi_Primary_airtime',
  'Avg Play Time(hrs)': 'dbi_top_kpiOverview_avg_play_time_hrs',
  Wishlists: 'dbi_metric_daily_wishlist',
  'Wishlists Total': 'dbi_metric_lifetime_wishlist',
  'Est Cumulative Units': 'dbi_metric_est_cumulative_units',
  'Lifetime Base Game Sales Units': 'dbi_metric_lifetime_base_game_sales_units',
  'Lifetime Total Revenue($)': 'dbi_metric_lifetime_total_revenue',
};

export const GSD_METRICS_NAMES_LOCALE_KEYS_MAP: {
  [key: string]: string;
} = {
  'Digital Units': 'dbi_metric_digital_units',
  'Physical Units': 'dbi_metric_gsd_physical_units',
};

export const STEAM_TOP_SELLERS_NAMES_LOCALE_KEYS_MAP: {
  [key: string]: string;
} = {
  Rank: 'dbi__metric_store_rank_top_seller_overview',
};

export const STEAM_TOP_WISH_LISTS_NAMES_LOCALE_KEYS_MAP: {
  [key: string]: string;
} = {
  Rank: 'dbi__metric_store_rank_top_wishlist',
};

export const CUSTOM_OVERVIEW_CARD_NAMES_LOCALE_KEYS_MAP: {
  [key: string]: string;
} = {
  all_reviews: 'dbi__metric_all_reviews',
};

export const USREVENUE_CARD_NAMES_LOCALE_KEYS_MAP: {
  [key: string]: string;
} = {
  LifetimeRevenue: 'dbi_metric_lifetime_revenue',
  D1afterreleaseRevenue: 'dbi_metric_d1_after_release_revenue',
  W1afterreleaseRevenue: 'dbi_metric_w1_after_release_revenue',
  M1afterreleaseRevenue: 'dbi_metric_m1_after_release_revenue',
  Y1afterreleaseRevenue: 'dbi_metric__y1_after_release_revenue',
  Y1aftereaRevenue: 'dbi_metric_y1_fter_ea_revenue',
  LastmonthRevenue: 'dbi_metric_last_month_Revenue',
  LifetimeSales: 'dbi_metric_lifetime_full_units',
  D1afterreleaseSales: 'dbi_metric_d1_after_release_full_units',
  W1afterreleaseSales: 'dbi_metric_w1_after_release_full_units',
  M1afterreleaseSales: 'dbi_metric_m1_after_release_full_units',
  Y1afterreleaseSales: 'dbi_metric_y1_after_release_full_units',
  Y1aftereaSales: 'dbi_metric_y1_after_ea_full_units',
  LastmonthSales: 'dbi_metric_last_month_full_units',
};

export const AMPERE_NAMES_LOCALE_KEYS_MAP: {
  [key: string]: string;
} = {
  LifetimeRevenue: 'dbi_metric_lifetime_revenue',
  D1afterreleaseRevenue: 'dbi_metric_d1_after_release_revenue',
  W1afterreleaseRevenue: 'dbi_metric_w1_after_release_revenue',
  M1afterreleaseRevenue: 'dbi_metric_m1_after_release_revenue',
  Y1afterreleaseRevenue: 'dbi_metric__y1_after_release_revenue',
  Y1aftereaRevenue: 'dbi_metric_y1_fter_ea_revenue',
  LastmonthRevenue: 'dbi_metric_last_month_Revenue',
  LifetimeSales: 'dbi_metric_lifetime_full_units',
  D1afterreleaseSales: 'dbi_metric_d1_after_release_full_units',
  W1afterreleaseSales: 'dbi_metric_w1_after_release_full_units',
  M1afterreleaseSales: 'dbi_metric_m1_after_release_full_units',
  Y1afterreleaseSales: 'dbi_metric_y1_after_release_full_units',
  Y1aftereaSales: 'dbi_metric_y1_after_ea_full_units',
  LastmonthSales: 'dbi_metric_last_month_full_units',
};

export const JUMPTO_KPITRENDS_MAMP: {
  [key: string]: string;
} = {
  lifetimerevenue: 'digitalRevenue',
  d1afterreleaserevenue: 'digitalRevenue',
  w1afterreleaserevenue: 'digitalRevenue',
  m1afterreleaserevenue: 'digitalRevenue',
  y1afterreleaserevenue: 'digitalRevenue',
  y1afterearevenue: 'digitalRevenue',
  lastmonthrevenue: 'digitalRevenue',
  lifetimesales: 'salesUnits',
  d1afterreleasesales: 'salesUnits',
  w1afterreleasesales: 'salesUnits',
  m1afterreleasesales: 'salesUnits',
  y1afterreleasesales: 'salesUnits',
  y1aftereasales: 'salesUnits',
  lastmonthsales: 'salesUnits',
  mau: 'mau',
  retentiond1: 'retention_d1',
  lifetime_player: 'lifetime_player',
  pcu: 'pcu',
  acu: 'acu',
  estprice: 'est_price',
  estcumulativeunits: 'est_cumulative_units',
  wishlists: 'wishlists',
  wishliststotal: 'wishlists_total',
  lifetimebasegamesalesunits: 'databrain__lifetime_base_game_sales_units',
  'lifetimetotalrevenue($)': 'databrain__lifetime_total_revenue',
} as any;

export const JUMPTO_KPITRENDS_APMERE_MAMP: {
  [key: string]: string;
} = {
  mau: 'ampere_mau',
  lifetime_player: 'ampere_lifetime_users',
  'avgplaytime(hrs)': 'ampere_avg_monthly_playtime',
  dau: 'ampere_dau',
  d1: 'ampere_d1',
  d7: 'ampere_d7',
} as any;

export const JUMPTO_PCCONSOLESTORERANK_MAMP: {
  [key: string]: string;
} = {
  'steam top wish lists': 'steam+top+wish+lists',
  'steam top sellers': 'steam+top+sellers',
} as any;
